var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-05-25
 * @brief EHP Status 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useState, useRef } from "react";
// recoli & state
import { useRecoilValue, useSetRecoilState, useResetRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { curSpgTreeState, nextSpgTreeState, curEhcTypeState, nextEhcTypeState, itemState, nextItemState, beforeItemState, assessmentListState, doneAssessmentState, checkStep, getCurItemCheck, curCheckValueDto, tempCheckValue, getCheckDone, getTempSave } from '../../../recoil/assessmentState';
//utils
import clog from "../../../utils/logUtils";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP Status 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function EhcCheckStep(props) {
    //const userInfo = useRecoilValue(userInfoState);
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const curSpgTree = useRecoilValue(curSpgTreeState);
    const setRecoilCurSpgTree = useSetRecoilState(curSpgTreeState);
    const nextSpgTree = useRecoilValue(nextSpgTreeState);
    const resetRecoilNextSpgTree = useResetRecoilState(nextSpgTreeState);
    //
    const curEhcType = useRecoilValue(curEhcTypeState);
    const setRecoilCurEhcType = useSetRecoilState(curEhcTypeState);
    const nextEhcType = useRecoilValue(nextEhcTypeState);
    const setRecoilNextEhcType = useSetRecoilState(nextEhcTypeState);
    const resetRecoilNextEhcType = useResetRecoilState(nextEhcTypeState);
    const beforeEhcType = useRecoilValue(nextEhcTypeState);
    //
    const curItem = useRecoilValue(itemState);
    const setRecoilCurItem = useSetRecoilState(itemState);
    const nextItem = useRecoilValue(nextItemState);
    const resetRecoilNextItem = useResetRecoilState(nextItemState);
    const beforeItem = useRecoilValue(beforeItemState);
    const setRecoilBeforeItem = useSetRecoilState(beforeItemState);
    const itemCheckList = useRecoilValue(assessmentListState);
    //const setRecoilItemCheckList = useSetRecoilState(assessmentListState);
    const tsItemCheckListInfo = useRecoilValue(doneAssessmentState);
    //const tsItemCheckList = useRecoilValue(getCheckValueDtoList);
    const setRecoilTsItemCheckListInfo = useSetRecoilState(doneAssessmentState);
    const resetRecoilTsItemCheckListInfo = useResetRecoilState(doneAssessmentState);
    const curCheckStep = useRecoilValue(checkStep);
    const setRecoilCurCheckStep = useSetRecoilState(checkStep);
    const resetRecoilCurCheckStep = useResetRecoilState(checkStep);
    const curItemCheck = useRecoilValue(getCurItemCheck);
    //const tsCheckVal = useRecoilValue(getCheckValueDto);
    const setRecoilTsCheckVal = useSetRecoilState(curCheckValueDto);
    const resetRecoilTsCheckVal = useResetRecoilState(curCheckValueDto);
    //
    const tempCheckVal = useRecoilValue(tempCheckValue);
    const setRecoilTempCheckVal = useSetRecoilState(tempCheckValue);
    const resetRecoilTempCheckVal = useResetRecoilState(tempCheckValue);
    const checkDone = useRecoilValue(getCheckDone);
    const isTempSave = useRecoilValue(getTempSave);
    //
    const { company, zone, subZone, room, spg } = props.curTreeData;
    const ingNum = Math.round((curCheckStep + 1) / itemCheckList.length * 100);
    const [isNextable, setIsNextable] = useState(true);
    const [comment, setComment] = useState("");
    const [saveComment, setSaveComment] = useState("");
    const [tsItemCheckList, setTsItemCheckList] = useState({ item: null, tsCheckList: null });
    const [tsCheckVal, setTsCheckVal] = useState({
        assessmentId: -1,
        checkItemId: -1,
        checkItemName: "",
        isChecked: false,
        value: "",
        valueType: "",
        comment: "",
        versionNo: ""
    });
    const [isCheckDisable, setIsCheckDisable] = useState(false);
    const [popupTempSave, setPopupTempSave] = useState("none");
    useEffect(() => {
        clog("IN CHECK STEP : IS TEMPSAVE : " + popupTempSave);
        if (isTempSave)
            setPopupTempSave("block");
    }, [isTempSave]);
    // step 변경 확인
    useEffect(() => {
        //check 없이 next step 갈때..check된 isNextable 초기화
        clog("IN EHCCHECK_STEP : INIT : curCheckStep : " + JSON.stringify(tempCheckVal));
        //setComment("");
        setIsNextable(true);
    }, [curCheckStep]);
    useEffect(() => {
        //check 없이 next step 갈때..check된 isNextable 초기화
        //clog("IN EHCCHECK_STEP : curItem : " + JSON.stringify(curItem));
        //clog("IN EHCCHECK_STEP : tsItemCheckListInfo : curItem 변경 여부 확인 / 임시체크 내부 초기화: " + JSON.stringify(tsItemCheckListInfo));
        //
        //setTsItemCheckList(tsItemCheckListInfo.checkValueDtoList); // 내부 체크 리스트 셋팅
        setTsItemCheckList({ item: curItem, tsCheckList: null });
        setTsCheckVal({
            assessmentId: -1,
            checkItemId: -1,
            checkItemName: "",
            isChecked: false,
            value: "",
            valueType: "",
            comment: "",
            versionNo: ""
        });
        setIsNextable(true);
        // 체크를 시작했으면...nextItem을 초기화 한다.    
    }, [curItem]);
    useEffect(() => {
        //clog("IN EHCCHECK_STEP : tsItemCheckList : 임시체크 내부 저장 변경 여부 확인 : " + (tsItemCheckList)?tsItemCheckList.length:0);
        clog("IN EHCCHECK_STEP : tsItemCheckListInfo : 임시체크 리코일 저장 변경 여부 확인 : " + curCheckStep + " : " + JSON.stringify(tsItemCheckListInfo));
        setTsItemCheckList({ item: curItem, tsCheckList: tsItemCheckListInfo.checkValueDtoList });
    }, [tsItemCheckListInfo]);
    useEffect(() => {
        //let tsVal = tempCheckVal.checkVal; // 임시저장정보로 셋팅
        let tsVal = {
            assessmentId: -1,
            checkItemId: -1,
            checkItemName: "",
            isChecked: false,
            value: "",
            valueType: "",
            comment: "",
            versionNo: ""
        };
        const imsiItem = tsItemCheckList.item;
        const imsiItemId = (imsiItem) ? imsiItem.itemId : -1;
        const imsiItemName = (imsiItem) ? imsiItem.itemName : "-1";
        const imsiItemCheckList = tsItemCheckList.tsCheckList;
        // xxxxxxxxxxxxxxxxxxxxxxx
        clog("IN EHCHCECK_STEP : curCheckStep, tsItemCheckList : " + curItem.itemName + " : " + imsiItemName);
        ((curItem.itemId === imsiItemId) && curItemCheck && imsiItemCheckList) && imsiItemCheckList.map((ts, idx) => {
            /*clog("CHECK LIST : " + curItem.itemName + " / " + imsiItemName + " : Value : " + ts.value
            + " : " + ts.checkItemId
            + " : " + curItemCheck.checkItemId);*/
            if ((curItem.itemName == imsiItemName) && (ts.checkItemId == curItemCheck.checkItemId)) {
                /*clog("CHECK LIST : CHECKED : " + curItem.itemName + " / " + imsiItemName +  " : " + (curItem.itemName == imsiItemName) + " : Value : " + ts.value
                + " : " + ts.checkItemId
                + " : " + curItemCheck.checkItemId);*/
                tsVal = ts;
            }
        });
        setTsCheckVal(tsVal);
    }, [curCheckStep, tsItemCheckList]);
    // 현재 체크값의 isChecked를 판단
    useEffect(() => {
        setComment(tsCheckVal.comment); // 20220706
        setSaveComment(tsCheckVal.comment); // 20220706
        setIsCheckDisable(tsCheckVal.isChecked);
    }, [tsCheckVal]);
    // onload 시 tempCheckVal 초기화
    // 수정 및 추가만
    function handleTsItemCheckList(item, val) {
        // delete
        const delList = (tsItemCheckList.tsCheckList == null) ? null : tsItemCheckList.tsCheckList.filter(ts => ts.checkItemId !== val.checkItemId);
        //clog("IN EHCCHECK_STEP : handleTsItemCheckList : " + JSON.stringify(delList));
        //(tsItemCheckList)&&setTsItemCheckList(tsItemCheckList.filter(ts=>ts.checkItemId !== val.checkItemId));
        // insert
        if (delList) {
            setTsItemCheckList({ item: item, tsCheckList: [...delList, val] });
        }
        else {
            setTsItemCheckList({ item: item, tsCheckList: [val] });
        }
    }
    function onClickNextFirstTempSave(nextYn, stepVal, item, checkVal) {
        return __awaiter(this, void 0, void 0, function* () {
            clog("IN EHCCHECKSTEP : onClickNextFirstTempSave : " + item.assessment.assessmentId);
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "POST",
                "appPath": "/api/v2/assessment/value",
                appQuery: {
                    preAssessmentId: item.assessment.preAssessmentId,
                    checkItemId: checkVal.checkItemId,
                    isChecked: checkVal.isChecked,
                    value: checkVal.value,
                    valueType: checkVal.valueType,
                    comment: checkVal.comment,
                    itemId: checkVal.itemId,
                    stepName: checkVal.stepName,
                    isTempSave: true,
                    versionNo: checkVal.versionNo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN EHCHECK_STEP : FIRST INSERT AFTER HANDEL : " + JSON.stringify(data.body));
                    //
                    const tmpCurItem = {
                        spgTree: {
                            company: company,
                            zone: zone,
                            subZone: subZone,
                            room: room,
                            spg: spg
                        },
                        ehcType: item.ehcType,
                        itemId: item.itemId,
                        itemName: item.itemName,
                        serialNo: item.serialNo,
                        itemStatus: item.itemStatus,
                        itemStep: item.echType + "_ING",
                        responsible: item.responsible,
                        assessment: {
                            preAssessmentId: item.assessment.preAssessmentId,
                            assessmentId: data.body.assessmentId,
                            totalComment: item.assessment.totalComment,
                            reportId: item.assessment.reportId,
                            updatedTime: item.assessment.updatedTime,
                            isTempSave: true //curItem.assessment.isTempSave
                        }
                    };
                    // 임시저장 확인 구분 
                    // 
                    if (nextYn) {
                        // 처음 저장 후, 다음 단계 이동 으로
                        // src : setRecoilBeforeItem(tmpCurItem); //등록 함수 안에서...// 목록 리프레쉬가 되면 괜찮을 텐데..        
                        setRecoilCurItem(tmpCurItem); // 처음 내역 저장
                        //------------
                        setRecoilCurCheckStep(stepVal); // 다음단계 이동
                        resetRecoilTempCheckVal();
                    }
                    else {
                        // 처음 저장 후, 단계 초기화 및 다음 아이템으로 이동
                        // src : setRecoilCurItem(tmpCurItem);
                        setRecoilBeforeItem(tmpCurItem); // 처음 내역 저장 //등록 함수 안에서...// 목록 리프레쉬가 되면 괜찮을 텐데..        
                        //------------------
                        ////////////////////////////
                        resetRecoilCurCheckStep(); // 임시저장에서는 임시저장후, 단계 초기화
                        resetRecoilTempCheckVal(); // 임시저장상태 초기화
                        // handle Item for List
                        setRecoilCurItem(nextItem); // 저장후, 이후 아이템으로 변경
                        //handle EhcType for Status
                        clog("IN ECHCHECKSTEP : HANDLE FIRST EHCTYPE : " + nextItem.ehcType + " : " + nextEhcType);
                        if (nextItem.ehcType != nextEhcType) { //현재 아이템의 ehcType과 nextEhcType이 틀린 경우
                            if (nextEhcType.length > 0) { // 단 nextEhcType이 사용자 선택으로 틀려진 경우
                                setRecoilCurEhcType(nextEhcType);
                            }
                        }
                        //handle spgTree for Tree
                        var citemSpgKey = String(curItem.spgTree.company.companyId) + curItem.spgTree.room.roomId + curItem.spgTree.zone.zoneId + String(curItem.spgTree.spg.spgId);
                        var nitemSpgKey = String(nextItem.spgTree.company.companyId) + nextItem.spgTree.room.roomId + nextItem.spgTree.zone.zoneId + String(nextItem.spgTree.spg.spgId);
                        var nSpgKey = String(nextSpgTree.company.companyId) + nextSpgTree.room.roomId + nextSpgTree.zone.zoneId + String(nextSpgTree.spg.spgId);
                        clog("IN ECHCHECKSTEP : HANDLE SPGTREE : " + (citemSpgKey == nSpgKey) + " : " + citemSpgKey + " : " + nSpgKey);
                        clog("IN ECHCHECKSTEP : HANDLE SPGTREE : " + (nitemSpgKey == nSpgKey) + " : " + nitemSpgKey + " : " + nSpgKey);
                        if (nitemSpgKey != nSpgKey) { //현재 아이템의 spgTree과 nextspgTree이 틀린 경우
                            if (nextSpgTree.spg.spgId >= 0) { // 단 nextspgTree이 사용자 선택으로 틀려진 경우
                                setRecoilCurSpgTree(nextSpgTree);
                            }
                        }
                    }
                    handleTsItemCheckList(item, data.body); // nextYn 과 상관없이 수행내역 추가
                }
                else { // api if
                    // need error handle
                }
            }
            return data.codeNum;
        });
    }
    function onClickNextTempSave(nextYn, stepVal, item, checkVal) {
        return __awaiter(this, void 0, void 0, function* () {
            clog("IN EHCCHECKSTEP : onClickNextTempSave : " + item.assessment.assessmentId);
            if (CUTIL.isnull(item.assessment.assessmentId)) {
                return;
            }
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": "/api/v2/assessment/value",
                appQuery: {
                    preAssessmentId: item.assessment.preAssessmentId,
                    checkItemId: checkVal.checkItemId,
                    isChecked: checkVal.isChecked,
                    value: checkVal.value,
                    valueType: checkVal.valueType,
                    comment: checkVal.comment,
                    itemId: checkVal.itemId,
                    stepName: checkVal.stepName,
                    assessmentId: item.assessment.assessmentId,
                    isTempSave: true,
                    versionNo: checkVal.versionNo,
                    //totalComment : comment
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN EHCHECK_STEP : INSERT AFTER HANDEL : " + JSON.stringify(data.body));
                    if (nextYn) {
                        //------------
                        setRecoilCurCheckStep(stepVal); // 다음단계 이동
                        resetRecoilTempCheckVal();
                    }
                    else {
                        //------------------
                        ////////////////////////////
                        resetRecoilCurCheckStep(); // 임시저장에서는 임시저장후, 단계 초기화
                        resetRecoilTempCheckVal(); // 임시저장상태 초기화
                        // handle Item for List
                        setRecoilCurItem(nextItem); // 저장후, 이후 아이템으로 변경
                        //handle EhcType for Status
                        clog("IN ECHCHECKSTEP : HANDLE FIRST EHCTYPE : " + nextItem.ehcType + " : " + nextEhcType);
                        if (nextItem.ehcType != nextEhcType) { //현재 아이템의 ehcType과 nextEhcType이 틀린 경우
                            if (nextEhcType.length > 0) { // 단 nextEhcType이 사용자 선택으로 틀려진 경우
                                setRecoilCurEhcType(nextEhcType);
                            }
                        }
                        //handle spgTree for Tree
                        var citemSpgKey = String(curItem.spgTree.company.companyId) + curItem.spgTree.room.roomId + curItem.spgTree.zone.zoneId + String(curItem.spgTree.spg.spgId);
                        var nitemSpgKey = String(nextItem.spgTree.company.companyId) + nextItem.spgTree.room.roomId + nextItem.spgTree.zone.zoneId + String(nextItem.spgTree.spg.spgId);
                        var nSpgKey = String(nextSpgTree.company.companyId) + nextSpgTree.room.roomId + nextSpgTree.zone.zoneId + String(nextSpgTree.spg.spgId);
                        clog("IN ECHCHECKSTEP : HANDLE SPGTREE : " + (citemSpgKey == nSpgKey) + " : " + citemSpgKey + " : " + nSpgKey);
                        clog("IN ECHCHECKSTEP : HANDLE SPGTREE : " + (nitemSpgKey == nSpgKey) + " : " + nitemSpgKey + " : " + nSpgKey);
                        if (nitemSpgKey != nSpgKey) { //현재 아이템의 spgTree과 nextspgTree이 틀린 경우
                            if (nextSpgTree.spg.spgId >= 0) { // 단 nextspgTree이 사용자 선택으로 틀려진 경우
                                setRecoilCurSpgTree(nextSpgTree);
                            }
                        }
                    }
                    handleTsItemCheckList(item, data.body); // 수행내역 추가
                    //setRecoilCurCheckStep(stepVal); // 다음단계 이동
                }
                else { // api if
                    // need error handle
                }
            }
            return data.codeNum;
        });
    }
    function onClickBeforeStep(stepVal) {
        var stepScore = getCheckScore();
        clog("IN EHCCHECKSTEP : BEFORE : " + stepVal + ": " + stepScore);
        setRecoilCurCheckStep(stepVal - 1);
    }
    //function onClickNextStep(stepVal, assessmentId, checkVal) {
    function onClickNextStep(stepVal, item, checkVal) {
        var stepScore = getCheckScore();
        clog("IN EHCCHECKSTEP : NEXT : ST : " + stepVal + " : SC : " + stepScore + " : NEXTABLE : " + isNextable + " : CHECKBLE : " + isCheckDisable);
        if ((!isCheckDisable) && (stepScore < 0)) {
            clog("IN EHCCHECKSTEP : NEXT===false&return : ST : " + stepVal + " : SC : " + stepScore + " : NEXTABLE : " + isNextable + " : CHECKBLE : " + isCheckDisable);
            setIsNextable(false);
            return;
        }
        else {
            setIsNextable(true);
            setIsCheckDisable(false);
        }
        var inputData = {
            checkItemId: checkVal.checkItemId,
            isChecked: isCheckDisable,
            value: stepScore,
            valueType: "number",
            comment: comment,
            itemId: item.itemId,
            stepName: checkVal.checkStepDto.name,
            isTempSave: true,
            versionNo: checkVal.versionNo,
        };
        var ret;
        if (CUTIL.isnull(item.assessment.assessmentId)) {
            ret = onClickNextFirstTempSave(true, stepVal + 1, item, inputData); // src : false => true
            //setRecoilCurCheckStep(stepVal+1); // 다음단계 이동
        }
        else {
            ret = onClickNextTempSave(true, stepVal + 1, item, inputData);
            //setRecoilCurCheckStep(stepVal+1); // 다음단계 이동
        }
        if (ret === 200) {
            //setRecoilCurCheckStep(stepVal+1); // 다음단계 이동
            //resetRecoilTempCheckVal();
        }
    }
    function getCheckScoreOld() {
        var divSelection = document.querySelector(".ehc__selectbtn");
        var stepScore = -1;
        if (CUTIL.isnull(divSelection))
            return stepScore;
        for (var i = 0; i < divSelection.children.length; i++) {
            var child = divSelection.children[i];
            var val = child.getAttribute("data-value");
            if (child.classList.contains("on")) {
                stepScore = parseInt(val);
                break;
            }
        }
        return stepScore;
    }
    function getCheckScore() {
        var ulSelection = document.querySelector(".ehc__selectbtn");
        var stepScore = -1;
        if (CUTIL.isnull(ulSelection))
            return stepScore;
        for (var i = 0; i < ulSelection.children.length; i++) {
            var childLi = ulSelection.children[i];
            if (childLi.children.length < 1)
                continue; // 'BUTTON' OR P tag
            var btnTag = childLi.children[0]; // 'BUTTON' tag
            var val = btnTag.getAttribute("data-value");
            if (btnTag.classList.contains("on")) {
                stepScore = parseInt(val);
                break;
            }
        }
        return stepScore;
    }
    function onClickComment(e) {
        e.preventDefault();
        //var btnComment = (e.target.tagName==="BUTTON")?e.target:e.currentTarget;
        var btnComment = document.querySelector(".btn-comment");
        var divPopupBoxin = document.querySelector(".popup-boxin");
        var btnCommentClose = document.querySelector(".popup-boxin .btn-close");
        //clog("btnComment : " + btnComment.tagName + " : CLASS : " + btnComment.className);
        if (!CUTIL.isnull(btnComment))
            btnComment.classList.toggle("on");
        if (!CUTIL.isnull(divPopupBoxin))
            divPopupBoxin.classList.toggle("on");
        if (CUTIL.isnull(btnCommentClose))
            return;
        btnCommentClose.addEventListener("click", function (e) {
            onClickComment(e); // 재귀호출
        });
    }
    function onClickSaveComment(e) {
        //alert("commet save and close!!");
        onClickComment(e); // for layer close
        setSaveComment(comment);
    }
    function onClickUpdateComment(e, type) {
        onClickComment(e); // for layer close
        if (type == "DELETE") {
            setComment("");
            setSaveComment("");
        }
        else { // update insert
            setSaveComment(comment);
        }
    }
    function enableScoreSelection() {
        var divSelection = document.querySelector(".ehc__selectbtn");
        if (CUTIL.isnull(divSelection))
            return;
        divSelection.classList.remove("error");
        var inputCheck = document.querySelector("#chkJ1");
        if (CUTIL.isnull(inputCheck))
            return;
        inputCheck.classList.remove("input-error");
    }
    // 판정불가 버튼 클릭 핸들링
    function handelOnclickCheckDisable() {
        enableScoreSelection();
        if (!isCheckDisable) { // true 셋팅되면
            setIsNextable(true);
        }
        setIsCheckDisable(!isCheckDisable);
    }
    function onClickScoreButton(e, checkVal) {
        enableScoreSelection();
        //
        var btnScore = (e.target.tagName === "BUTTON") ? e.target : e.currentTarget;
        var btnCl = btnScore.className;
        var chkScore = -1;
        //var parentElement = btnScore.parentElement;
        var ulSelection = btnScore.closest(".ehc__selectbtn");
        for (var i = 0; i < ulSelection.children.length; i++) {
            var childLi = ulSelection.children[i];
            if (childLi.children.length < 1)
                continue; // 'BUTTON' OR P tag
            var btnTag = childLi.children[0]; // 'BUTTON' tag
            btnTag.classList.remove("on");
        }
        if (btnCl == "on") {
            //
            btnScore.classList.remove("on");
            chkScore = -1;
        }
        else {
            if (btnScore.classList.contains("errorpoint"))
                btnScore.classList.remove("errorpoint");
            btnScore.classList.add("on");
            chkScore = btnScore.getAttribute("data-value");
        }
        //
        var cval = {
            item: curItem,
            checkVal: {
                assessmentId: curItem.assessment.assessmentId,
                checkItemId: checkVal.checkItemId,
                checkItemName: checkVal.checkItemName,
                isChecked: false,
                value: String(chkScore),
                valueType: "number",
                comment: comment,
                versionNo: checkVal.versionNo,
            },
            stepDone: false
        };
        const checkValue = (cval.checkVal.value.length > 0) ? parseInt(cval.checkVal.value) : -1;
        if (checkValue > -1) {
            setIsNextable(true); // sjpark 20220708
            setRecoilTempCheckVal(cval);
            setTsCheckVal(cval.checkVal);
        }
        else {
            resetRecoilTempCheckVal();
        }
    }
    function hadleTempSave(val) {
        var inputData = {
            checkItemId: tempCheckVal.checkVal.checkItemId,
            isChecked: tempCheckVal.checkVal.isChecked,
            value: tempCheckVal.checkVal.value,
            valueType: "number",
            comment: tempCheckVal.checkVal.comment,
            itemId: tempCheckVal.item.itemId,
            stepName: tempCheckVal.item.ehcType,
            isTempSave: true,
            versionNo: tempCheckVal.checkVal.versionNo,
        };
        /*
          -- ITEM 변경시
          0 현재 아이템이 체크되어 있지 않으면...클릭한 아이템을 현재 아이템으로 함
          1. LIST에서 점수 클릭시, 임시저장 여부 저장
          2. LIST에서 ITEM 변경/클릭시, 클릭한 항목을 다음 ITEM의 상태를 저장
          -- TreeData 변경시
          -- Status 변경시
        */
        var ret;
        if (val) {
            // ture, 임시 저장 후, 다른 아이템으로 진행, 0단계로 이동
            clog("IN EHCCHECK_STEP : 임시저장 후 임시저장리스트 초기화");
            //
            //handle Item for List
            resetRecoilTsItemCheckListInfo(); // 아이템 임시저장된 체크리스트 초기화-> 함수에서 처리
            if (CUTIL.isnull(tempCheckVal.item.assessment.assessmentId)) {
                onClickNextFirstTempSave(false, -1, tempCheckVal.item, inputData); // src : true ==> false
            }
            else {
                onClickNextTempSave(false, -1, tempCheckVal.item, inputData);
            }
        }
        else {
            // false, 임시 저장하지 않고, 이전 아이템으로 변경
            clog("IN EHCCHECK_STEP TEMPSAVE : 취소 : " + "clickItem/nextItem 초기화");
            resetRecoilNextItem(); // clickItem/nextItem 초기화
            clog("IN EHCCHECK_STEP TEMPSAVE : 취소 : " + "저장않고 후, 이전 아이템으로 변경");
            setRecoilCurItem(curItem); // 저장않고 후, 이전 아이템으로 변경
            //handle EhcType for Status
            resetRecoilNextEhcType();
            if (curItem.ehcType != curEhcType) {
                setRecoilCurEhcType(curEhcType);
            }
            //handle spgTree for Tree
            resetRecoilNextSpgTree();
            if (curItem.spgTree != curSpgTree) {
                setRecoilCurSpgTree(curSpgTree);
            }
        }
    }
    return (((!checkDone) && (curItemCheck)) &&
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ehc__detail" },
                React.createElement("p", { className: "tit" }, (curCheckStep + 1) + "." + curItemCheck.checkItemName),
                React.createElement("p", { className: "txt" }, curItemCheck.description)),
            clog("IN EHCCHECSTEP : AFTER : " + isNextable + " : " + JSON.stringify(tsCheckVal)),
            React.createElement("ul", { className: `ehc__selectbtn ${(isNextable) ? "" : "error"}` }, curItemCheck.checkItemRefDtoList.map((ref, idx) => ((ref.reference.length <= 0)
                ? React.createElement("li", { key: "checkstepli_" + "_" + idx },
                    React.createElement("button", { key: "checkstep_" + curItemCheck.checkItemId + "_" + idx, type: "button", className: (CUTIL.isnull(tsCheckVal)) ? "" : (parseInt(tsCheckVal.value) == ref.score) ? "on" : "", "data-value": ref.score, disabled: true },
                        React.createElement("span", null, ref.score)),
                    (isNextable) ? React.createElement(React.Fragment, null) : (idx == 0) ? React.createElement("p", { className: "input-errortxt" }, "\uD544\uC218 \uC785\uB825 \uD56D\uBAA9\uC785\uB2C8\uB2E4.") : React.createElement(React.Fragment, null))
                : React.createElement("li", { key: "checkstepli_" + "_" + idx },
                    React.createElement("button", { key: "checkstep_" + curItemCheck.checkItemId + "_" + idx, type: "button", className: (!isNextable) ? "errorpoint" : (CUTIL.isnull(tsCheckVal)) ? "" : (parseInt(tsCheckVal.value) == ref.score) ? "on" : "", "data-value": ref.score, onClick: (e) => onClickScoreButton(e, curItemCheck), disabled: (isCheckDisable) ? true : false },
                        React.createElement("span", null, ref.score)),
                    (isNextable) ? React.createElement(React.Fragment, null) : (idx == 0) ? React.createElement("p", { className: "input-errortxt" }, "\uD544\uC218 \uC785\uB825 \uD56D\uBAA9\uC785\uB2C8\uB2E4.") : React.createElement(React.Fragment, null))))),
            React.createElement("div", { className: "tbl__top" },
                React.createElement("div", { className: "left" },
                    React.createElement("input", { type: "checkbox", id: "chkJ1", name: "chkJudg", className: (isNextable) ? "" : "input-error", onChange: (e) => { handelOnclickCheckDisable(); }, checked: isCheckDisable }),
                    React.createElement("label", { htmlFor: "chkJ1" }, "\uD310\uC815\uBD88\uAC00"),
                    (saveComment && (saveComment.length > 0))
                        ? React.createElement("button", { type: "button", className: "btn btn-comment-check", "data-pop": "pop-comment", onClick: (e) => onClickComment(e) },
                            React.createElement("span", null, "\uC758\uACAC\uD655\uC778"))
                        : React.createElement("button", { type: "button", className: "btn btn-comment", "data-pop": "pop-comment", onClick: (e) => onClickComment(e) },
                            React.createElement("span", null, "\uC758\uACAC\uC791\uC131")))),
            React.createElement("div", { className: "tbl-list" },
                React.createElement("table", { summary: "\uC810\uC218, \uD3C9\uAC00\uAE30\uC900 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD310\uC815 List \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uD310\uC815 List"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { width: "25%" } }),
                        React.createElement("col", { style: { width: "75%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }, "\uC810\uC218"),
                            React.createElement("th", { scope: "col" }, "\uD3C9\uAC00\uAE30\uC900"))),
                    React.createElement("tbody", null, curItemCheck.checkItemRefDtoList.map((ref, idx) => (React.createElement("tr", { key: "checkstep_" + idx },
                        React.createElement("td", null,
                            ref.score,
                            "\uC810"),
                        React.createElement("td", { className: "txt-left" }, ref.reference))))))),
            React.createElement("div", { className: "tbl__bottom" },
                React.createElement("div", { className: "ehc__step" },
                    React.createElement("p", { className: "hide" }, "e-HC \uD3C9\uAC00 \uB2E8\uACC4"),
                    React.createElement("div", { className: "progressbar" },
                        React.createElement("span", { className: "step" },
                            curCheckStep + 1,
                            " of ",
                            itemCheckList.length),
                        React.createElement("div", { className: "progress-value" },
                            React.createElement("progress", { value: ingNum, max: "100" }),
                            React.createElement("p", { className: "value" },
                                React.createElement("span", { style: { left: `${ingNum}%` } },
                                    ingNum,
                                    "%"))))),
                React.createElement("div", { className: "btn__wrap" },
                    (curCheckStep > 0)
                        ? React.createElement("button", { type: "button", className: "bg-transparent", onClick: (e) => onClickBeforeStep(curCheckStep) },
                            React.createElement("span", null, "\uC774\uC804"))
                        : React.createElement("button", { type: "button", className: "bg-transparent", disabled: true },
                            React.createElement("span", null, "\uC774\uC804")),
                    ((curCheckStep + 1) <= itemCheckList.length)
                        //?<button type="button" onClick={(e)=>onClickNextStep(curCheckStep, curItem.assessment.assessmentId, curItemCheck)}><span>다음</span></button>
                        ? React.createElement("button", { type: "button", onClick: (e) => onClickNextStep(curCheckStep, curItem, curItemCheck) },
                            React.createElement("span", null, "\uB2E4\uC74C"))
                        : React.createElement("button", { type: "button", className: "bg-transparent" },
                            React.createElement("span", null, "\uB2E4\uC74C")))),
            React.createElement("div", { id: "pop-comment", className: "popup-boxin" },
                React.createElement("div", { className: "page-detail" },
                    React.createElement("div", { className: "popup__head-opinion" },
                        React.createElement("h1", null, "\uC758\uACAC\uC791\uC131"),
                        React.createElement("button", { className: "btn btn-close" },
                            React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                    React.createElement("div", { className: "popup__body-opinion" },
                        React.createElement("p", { className: "txtnum" },
                            comment.length,
                            " / 120"),
                        React.createElement("textarea", { placeholder: "\uC758\uACAC\uC744 \uC785\uB825\uD558\uC138\uC694.", value: comment, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, setComment), onChange: (e) => setComment(e.target.value) })),
                    React.createElement("div", { className: "popup__footer-opinion" }, (saveComment && (saveComment.length > 0))
                        ? React.createElement(React.Fragment, null,
                            React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickUpdateComment(e, "DELETE") },
                                React.createElement("span", null, "\uC0AD\uC81C")),
                            React.createElement("button", { type: "button", onClick: (e) => onClickUpdateComment(e, "UPDATE") },
                                React.createElement("span", null, "\uC218\uC815")))
                        : React.createElement(React.Fragment, null,
                            React.createElement("button", { type: "button", onClick: (e) => onClickUpdateComment(e, "INSERT") },
                                React.createElement("span", null, "\uC800\uC7A5")))))),
            React.createElement(PopupTempSave, { popupToggle: popupTempSave, setPopupToggle: setPopupTempSave, hadleTempSave: hadleTempSave })));
}
export default EhcCheckStep;
function PopupTempSave(props) {
    const srcToggleVal = props.popupToggle;
    const setPopupToggle = props.setPopupToggle;
    const hanleParentTempSave = props.hadleTempSave;
    const [toggleVal, setToggleVal] = useState(srcToggleVal);
    const [popupObj, setPopupObj] = useState(null);
    const ref = useRef(null);
    useEffect(() => {
        setPopupObj(ref.current);
    });
    useEffect(() => {
        setToggleVal(srcToggleVal);
    }, [srcToggleVal]);
    function onClickClose(e) {
        (popupObj) && popupObj.style.setProperty("display", "none");
        setPopupToggle("none");
    }
    function onClickTrue(e) {
        hanleParentTempSave(true);
        onClickClose(e);
    }
    function onClickFalse(e) {
        hanleParentTempSave(false);
        onClickClose(e);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref, id: "pop-basic", className: "popup-boxin popup-basic", style: { display: `${toggleVal}` } },
            React.createElement("div", { className: "page-detail" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null, "e-HC"),
                    React.createElement("button", { className: "btn btn-close", onClick: (e) => onClickClose(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("p", null,
                        "\uC810\uAC80\uC774 \uC644\uB8CC\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uB098\uAC00\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                        React.createElement("br", null),
                        "\uD398\uC774\uC9C0\uB97C \uBC97\uC5B4\uB0A0 \uACBD\uC6B0, \uC9C4\uD589 \uB0B4\uC6A9\uC740 \uC784\uC2DC \uC800\uC7A5\uB429\uB2C8\uB2E4.")),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickFalse(e) },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", onClick: (e) => onClickTrue(e) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
